export const lesaKeys = {
  all: ({ page, search }: { page: number; search: string }) => [
    'LESA_LIST',
    page,
    search,
  ],
};
